import { AnimatePresence } from 'framer-motion'

export const AnimatePresenceIfEnabled: React.FC<{ enabled: boolean }> = ({ children, enabled }) => {
  if (!enabled) {
    return <>{children}</>
  }

  return <AnimatePresence>{children}</AnimatePresence>
}
